export enum InsuranceBranch {
  BRANCH_21 = 'BRANCH_21',
  BRANCH_23 = 'BRANCH_23',
  MIX = 'MIX',
  OTHER = 'OTHER',
}
